module.exports = __webpack_public_path__ + "img/block.15d3bd38.svg";